import log from 'salvo-lite/log'
import natSort from 'natsort'

class SortElements {
    constructor (theme, elem) {
        this.elem = elem
        this.elemsToSort = this.elem.querySelectorAll('[data-sort-value]')
    }

    onInit () {
        log.debug(this.constructor.name, 'Init')
        let newElems = []

        if (this.elem.hasAttribute('data-size-sort')) {
            let order = ['xs', 'xs/s', 's', 's/m', 'm', 'm/l', 'l', 'l/xl', 'xl', 'xl/xxl', 'xxl', 'os']
            for (let i = 0; i < 100; i++) {
                order.push(`${i}`)
            }
            newElems = [].slice.call(this.elemsToSort).sort((a, b) => {
                let aSort = order.indexOf(a.dataset.sortValue.toLowerCase().trim())
                let bSort = order.indexOf(b.dataset.sortValue.toLowerCase().trim())
                if (aSort < bSort) {
                    return -1
                }
                if (aSort > bSort) {
                    return 1
                }
                return 0
            })
        } else {
            let sorter = natSort()
            newElems = [].slice.call(this.elemsToSort).sort((a, b) => {
                return sorter(a.dataset.sortValue, b.dataset.sortValue)
            })
        }
        while (this.elem.hasChildNodes()) {
            this.elem.removeChild(this.elem.lastChild)
        }
        for (let newElem of newElems) {
            this.elem.appendChild(newElem)
        }
        this.elem.classList.add(`${this.constructor.name.toLowerCase()}--initialized`)
        log.debug(this.constructor.name, 'Init Fin')
    }
}

export default SortElements



// WEBPACK FOOTER //
// ./src/resources/scripts/components/SortElements.js